import { ProviderName } from "~frontend/__generated__/graphql";

export enum PhoneNumberSortBy {
  CreatedAtDesc = "CREATED_AT_DESC",
  CreatedAtAsc = "CREATED_AT_ASC",
  NumberAsc = "NUMBER_ASC",
  NumberDesc = "NUMBER_DESC",
}

export const PHONE_NUMBER_SORTS: { value: PhoneNumberSortBy; label: string }[] =
  [
    {
      value: PhoneNumberSortBy.CreatedAtDesc,
      label: "Created At, Newest First",
    },
    {
      value: PhoneNumberSortBy.CreatedAtAsc,
      label: "Created At, Oldest First",
    },
    {
      value: PhoneNumberSortBy.NumberAsc,
      label: "Number, 1-9",
    },
    {
      value: PhoneNumberSortBy.NumberDesc,
      label: "Number, 9-1",
    },
  ];

export const PROVIDER_LABELS = Object.values(ProviderName).map(provider => ({
  value: provider,
  label: provider,
}));
